import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc86dd9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-card_tooltip-content" }
const _hoisted_2 = { class: "task-card_tooltip-content" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 4,
  class: "task-card_status"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "task-card__menu-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-card__negative" }, "Удалить тикет", -1))

import {
  computed,
  ComputedRef,
  CSSProperties,
  inject,
  nextTick,
  onMounted,
  onUnmounted,
  PropType,
  Ref,
  ref,
  useSlots,
  watch,
} from 'vue';
import {
  TirPmIconView,
  TirPmContextMenuMouseButtonEnum,
  TirPmContextMenuButton,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmTooltipElement,
  TirPmContextMenu,
  TirPmRouterLink,
} from 'tir-components';
import { ListBulletIcon, Bars3BottomLeftIcon } from 'tir-style-system/icons/solid';
import { RouterLink, useRouter } from 'vue-router';
import { RemoveTaskModal } from '@/components';
import NamespaceIconView from '@/pages/project-namespaces-page/components/namespace-card/namespace-icon-view.vue';
import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '@/components/tir-pm-list/models';
import { TaskViewElementEnum } from '@/components/tasks-kanban/enums';
import { OrderTaskModel, TaskColumnModel, TeammateModel } from '../../models';
import {
  TaskCardDifficulty,
  TaskCardEstimateTime,
  TaskCardPriority,
  TaskCardStatus,
  TaskCardWorkTime,
  TaskCardPerformers,
} from '@/components/tir-pm-list/components/task-card/components';
import { copyToClipboard } from '@/components/task-forms/utils';
import {
  ArrowTopRightOnSquareIcon,
  ClipboardDocumentIcon,
  CurtainIcon,
  MapIcon,
  TrashIcon,
} from 'tir-style-system/icons/outline';
import { CurrentUser } from 'tir-pm-user-core';
import GetEmployeesWithAccessToProjectItemModel from '@/pages/monitorings/models/GetEmployeesWithAccessToProjectItemModel';
import PerformerListByOrder from '@/components/tasks-kanban/components/PerformerListByOrder.vue';
import { TaskHistoryOrder } from './components';
import { ProjectModel } from '@/models';

/**Слоты */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card',
  props: {
  /**Юзер */
  user: { type: Object as PropType<TeammateModel> },
  /**Укороченная информация параметров */
  shortInfoParameter: {
    type: Boolean,
    default: false,
  },
  /**Данные задачи */
  task: { type: Object as PropType<OrderTaskModel>, required: true },
  /**Колонки */
  columns: { type: Array as PropType<TaskColumnModel[]>, default: () => [] },
  /**Страница Все задачи текущего юзера */
  checkAllTasks: { type: Boolean as PropType<boolean>, default: false },
  /**Настройки отображения */
  viewSettings: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    default: () => [
      TaskViewElementEnum.Namespace,
      TaskViewElementEnum.Queue,
      TaskViewElementEnum.Number,
      TaskViewElementEnum.Name,
      TaskViewElementEnum.Status,
      TaskViewElementEnum.Difficulty,
      TaskViewElementEnum.Priority,
      TaskViewElementEnum.EstimateTime,
      TaskViewElementEnum.WorkTime,
    ],
  },
  /**Выбранный исполнитель */
  selectPerformer: { type: Object as PropType<GetEmployeesWithAccessToProjectItemModel> },
  /**Ширина карточки */
  width: { type: String, default: '100%' },
  /**Дизейбл */
  isDisabled: {
    type: Boolean,
    default: false,
  },
  /**Возможность форматировать очередность */
  changeAccess: {
    type: Boolean,
  },
  /**Заливка */
  isFill: {
    type: Boolean,
    default: false,
  },
  /**Слот слева всегда видим */
  slotLeftVisible: {
    type: Boolean,
    default: false,
  },
  /**Таблица на странице мониторинга по тикетам */
  monitoringTicketPage: { type: Boolean, default: false },
  /**Скрыть пункты Открыть в шторке и Удалить */
  hideOpenAndDelete: { type: Boolean, default: false },
  /**Расположить статус в левой части таблицы */
  isStatusLeftBlock: { type: Boolean, default: false },
  /**Скрыть иконку у названия */
  hideIconName: { type: Boolean, default: false },
  /**Таблица на странице мониторинга по тикетам */
  monitoringPage: { type: Boolean, default: false },
},
  emits: ["openTaskDrawer", "removeTask"],
  setup(__props, { emit }) {

const props = __props;

const slots = useSlots();
/**Роутер */
const router = useRouter();

// #region defineProps
/**Параметры */

// #endregion defineProps

// #region defineEmits

// #endregion defineEmits

// #region Переменные
const parameterTypes = [
  TaskViewElementEnum.Difficulty,
  TaskViewElementEnum.Performers,
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.Status,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
];
// #endregion Переменные

// #region refs
/**Ссылка на компонент контекстного меню */
const $contextMenu = ref<InstanceType<typeof TirPmContextMenu>>();
/**Отображать схему задачи */
const showSchema = ref(false);
/**Элемент обертки */
const $wrapper = inject('wrapperElement') as Ref<HTMLDivElement>;

/**Является ли юзер админом проекта */
const isProjectAdmin = inject('isAdminProject') as Ref<boolean>;
/**Является ли юзер овнером */
const isOwner = ref(CurrentUser.Roles.includes(2));
/**Окно удаления задачи */
const $removeTaskModal = ref<InstanceType<typeof RemoveTaskModal>>();
/**Перетаскивается ли элемент */
const isDragging = ref(false);
/**Является ли элмент ссылкой */
const isLink = ref(true);

// #endregion refs

// #region computed
/**Активен левый слот */
const haveLeftSlot = computed(() => slots.left?.());
/**Минимальная ширина */
const minWidth = computed(() => {
  if (props.columns.some((column) => !column.MinWidth)) return 'auto';

  const columnsCalcStr = props.columns.map((column) => column.MinWidth).join(' + ');

  return `calc(${columnsCalcStr} + ${0.75 * (props.columns.length - 1)}rem + 1.25rem)`;
});
/**Стили карточки */
const style = computed<CSSProperties>(() => ({ width: props.width, minWidth: minWidth.value }));

const parameterColumns = computed(() => {
  const filtredColumns = props.columns.filter(
    (column) => parameterTypes.includes(column.Type) && props.viewSettings.includes(column.Type),
  );
  return filtredColumns.map((column) => {
    return new ListItemModel({
      Type: column.Type,
      Width: column.Width,
      MinWidth: column.MinWidth,
    });
  });
});

const statusColumn = computed(() => {
  const column = props.columns.find(
    (column) =>
      column.Type === TaskViewElementEnum.Status && props.viewSettings.includes(column.Type),
  );

  return column
    ? new ListItemModel({
        Type: column.Type,
        Width: column.Width,
        MinWidth: column.MinWidth,
      })
    : null;
});

const elementsStyles = computed<
  Record<'Project' | 'Namespace' | 'Queue' | 'Id' | 'Name' | 'Status', CSSProperties>
>(() => {
  const projectColumn = getColumnByViewElement(TaskViewElementEnum.Project);
  const namespaceColumn = getColumnByViewElement(TaskViewElementEnum.Namespace);
  const queueColumn = getColumnByViewElement(TaskViewElementEnum.Queue);
  const idColumn = getColumnByViewElement(TaskViewElementEnum.Number);
  const status = getColumnByViewElement(TaskViewElementEnum.Status);
  const nameColumn = getColumnByViewElement(TaskViewElementEnum.Name);

  return {
    Project: {
      width: projectColumn?.Width ?? '1.5rem',
      minWidth: projectColumn?.MinWidth,
    },
    Namespace: {
      width: namespaceColumn?.Width ?? '1.5rem',
      minWidth: namespaceColumn?.MinWidth,
    },
    Queue: {
      width: queueColumn?.Width ?? '13rem',
      minWidth: queueColumn?.MinWidth,
    },
    Id: {
      width: idColumn?.Width ?? '5rem',
      minWidth: idColumn?.MinWidth,
    },
    Status: {
      width: status?.Width ?? '5rem',
      minWidth: status?.MinWidth,
    },
    Name: {
      width: nameColumn?.Width ?? '65.8125rem',
      minWidth: nameColumn?.MinWidth,
    },
  };
});
// #endregion computed

// #region Хуки жизненного цикла
onMounted(() => {
  if ($wrapper.value) {
    $wrapper.value.addEventListener('scroll', onScroll);
  }
});
onUnmounted(() => {
  if ($wrapper.value) {
    $wrapper.value.removeEventListener('scroll', onScroll);
  }
});
// #endregion Хуки жизненного цикла

// #region Функции
/**При скролле обертки */
const onScroll = () => {
  $contextMenu.value?.close();
};

const getColumnByViewElement = (viewElement: TaskViewElementEnum) => {
  return props.columns.find((column) => column.Type === viewElement);
};

/**Получение компонента для параметра задачи */
const getTaskParameterComponent = (type: TaskViewElementEnum) => {
  switch (type) {
    case TaskViewElementEnum.Difficulty:
      return TaskCardDifficulty;
    case TaskViewElementEnum.Priority:
      return TaskCardPriority;
    case TaskViewElementEnum.Status:
      return TaskCardStatus;
    case TaskViewElementEnum.Performers:
      return TaskCardPerformers;
    case TaskViewElementEnum.EstimateTime:
      return TaskCardEstimateTime;
    case TaskViewElementEnum.WorkTime:
      return TaskCardWorkTime;
  }
};

/**Открыть карту проекта */
const openSchema = computed(() => {
  return router.resolve({
    name: 'project-map',
    params: {
      taskId: props.task.Id,
      projectId: props.task.ProjectId,
    },
  });
});

/**Открыть детальную страницу */
const goToDetail = computed(() => {
  return router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.task.ProjectId,
      queueId: props.task.Queues[0].Id,
      taskId: props.task.Id,
      namespaceId: props.task.NamespaceInfo[0].Id,
    },
  });
});
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'teammate-card',
      life: life ?? 2000,
      closable: true,
    }),
  );
};

/**Скопировать название и ссылку */
const copyNameAndLinkTask = async () => {
  if (!props.task.ProjectId || !props.task.Queues[0].Id) return;

  const route = router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.task.ProjectId,
      namespaceId: props.task.NamespaceInfo[0].Id,
      queueId: props.task.Queues[0].Id,
      taskId: props.task.Id,
    },
  });

  if (!route?.href) return;

  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = origin + route.href;
  const textContent = `${props.task.Id} ${props.task.Name}`;

  if (await copyToClipboard(`[${textContent}](${link})`)) {
    $contextMenu.value.close();
    addNotification('Название и ссылка тикета скопирована');
    console.log(6);
  }
};
/**Открыть окно удаления задачи */
const openRemoveModal = (id: number, name: string) => {
  $removeTaskModal.value?.open(id, name);
};
/**Удаление задачи из списка */
const onSuccessRemove = (taskId: number) => {
  emit('removeTask', taskId);
};

/**Скопировать название */
const copyNameTask = async () => {
  const taskData = {
    number: props.task.Id,
    name: props.task.Name,
  };

  if (await copyToClipboard(taskData.number + ' ' + taskData.name)) {
    $contextMenu.value.close();
    addNotification('Название тикета скопировано');
  }
};
/**Перетаскивается ли элемент */
const waitMouseUp = () => {
  return new Promise<void>((resolve) => {
    isDragging.value = false;

    const startTime = Date.now();

    const onMouseUp = () => {
      const duration = Date.now() - startTime;

      isDragging.value = duration >= 300;

      document.removeEventListener('mouseup', onMouseUp);
      isLink.value = true;
      resolve();
    };

    document.addEventListener('mouseup', onMouseUp, { once: true });
  });
};
/**Открыть задачу в шторке */
const openInDrawer = async () => {
  isLink.value = false;
  await waitMouseUp();
  if (!props.task.ProjectId || !props.task.HasAccessToTask || isDragging.value) return;
  $contextMenu.value?.close();
  emit('openTaskDrawer', props.task.Id);
  isLink.value = true;
};
// #endregion Функции

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmContextMenu), {
    ref_key: "$contextMenu",
    ref: $contextMenu,
    "min-width": "24.25rem",
    maxHeight: "max-content",
    "trigger-buttons": [_unref(TirPmContextMenuMouseButtonEnum).Right]
  }, {
    content: _withCtx(() => [
      (__props.task.HasAccessToTask)
        ? (_openBlock(), _createBlock(_unref(RouterLink), {
            key: 0,
            to: goToDetail.value,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TirPmContextMenuButton), { class: "task-card__menu-item" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "task-card__icon" }),
                  _createTextVNode(" Открыть в новой вкладке ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (__props.task?.ProjectId && __props.task.HasAccessToTask)
        ? (_openBlock(), _createBlock(_unref(RouterLink), {
            key: 1,
            to: openSchema.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TirPmContextMenuButton), { class: "task-card__menu-item" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MapIcon), { class: "task-card__icon" }),
                  _createTextVNode(" Посмотреть карту проекта ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(TirPmContextMenuButton), {
        onClick: copyNameAndLinkTask,
        class: "task-card__menu-item"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ClipboardDocumentIcon), { class: "task-card__icon" }),
          _createTextVNode(" Скопировать название и ссылку ")
        ]),
        _: 1
      }),
      _createVNode(_unref(TaskHistoryOrder), {
        userId: __props.user?.Id,
        taskId: __props.task?.Id
      }, null, 8, ["userId", "taskId"]),
      (__props.task.Performers.length)
        ? (_openBlock(), _createBlock(PerformerListByOrder, {
            key: 2,
            taskInfo: __props.task,
            onClosePopover: _cache[5] || (_cache[5] = ($event: any) => ($contextMenu.value.close()))
          }, null, 8, ["taskInfo"]))
        : _createCommentVNode("", true),
      ((_unref(isProjectAdmin) || isOwner.value) && !__props.hideOpenAndDelete)
        ? (_openBlock(), _createBlock(_unref(TirPmContextMenuButton), {
            key: 3,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (openRemoveModal(__props.task.Id, __props.task.Name)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(TrashIcon), { class: "task-card__menu-icon task-card__negative" }),
                _hoisted_8
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TirPmRouterLink), {
        isDisabled: 
        !props.task.ProjectId ||
        !props.task.Queues.length ||
        !props.task.NamespaceInfo.length ||
        !props.task.HasAccessToTask ||
        !isLink.value
      ,
        to: goToDetail.value,
        class: _normalizeClass([
        'task-card',
        { 'task-card__data-table': __props.monitoringPage },
        { 'is-disabled': __props.isDisabled, 'is-fill': __props.isFill },
        { 'task-card__change-access': __props.changeAccess },
        { 'task-card__order-style-task': __props.task.IsHighlighted },
        { 'task-card__order-style-task--by-employee': __props.task.IsHighlighted && __props.task.ZmkType === 2 },
        {
          'task-card__order-style-task--by-employee-no-access':
            __props.task.IsHighlighted && __props.task.ZmkType === 2 && !__props.task.HasAccessToTask,
        },
        { 'task-card__order-style-task--no-access': !__props.task.HasAccessToTask },
        {
          'task-card__deadline-missed':
            !!props.selectPerformer?.UserId && props.task.EstimateTime < props.task.WorkTime,
        },
        {
          'task-card__deadline-success':
            !!props.selectPerformer?.UserId &&
            props.task.EstimateTime > props.task.WorkTime &&
            props.task.WorkTime > 0,
        },
        {
          'task-card__deadline-no-estimated-time':
            !!props.selectPerformer?.UserId && !props.task.EstimateTime && props.task.WorkTime > 0,
        },
      ]),
        style: _normalizeStyle(style.value),
        onMousedown: [
          _withModifiers(openInDrawer, ["left","prevent"]),
          _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          _cache[4] || (_cache[4] = _withModifiers(() => {}, ["middle","prevent"]))
        ],
        onDragstart: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Project))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "task-card_project",
                style: _normalizeStyle(elementsStyles.value.Project)
              }, [
                (__props.task?.Project)
                  ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
                      key: 0,
                      width: "12.5rem"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(__props.task.Project.Name), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(TirPmIconView), {
                          size: 24,
                          "is-rounded": "",
                          "color-code": __props.task.Project.PreviewColor,
                          "image-load-url": __props.task.Project.ImageUrl,
                          "is-bordered": false
                        }, {
                          mainSlot: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.task.Project.Name?.[0]), 1)
                          ]),
                          _: 1
                        }, 8, ["color-code", "image-load-url"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true),
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Namespace))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "task-card_namespace",
                style: _normalizeStyle(elementsStyles.value.Namespace)
              }, [
                (__props.task?.NamespaceInfo?.length)
                  ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), { key: 0 }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.task.NamespaceInfo[0].Name), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(NamespaceIconView, {
                          icon: __props.task.NamespaceInfo[0].IconUrl,
                          color: __props.task.NamespaceInfo[0].Color
                        }, null, 8, ["icon", "color"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true),
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Queue))
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "task-card_queue",
                style: _normalizeStyle(elementsStyles.value.Queue)
              }, [
                _createVNode(_unref(TirPmTooltipElement), { class: "task-card_tooltip-block" }, _createSlots({
                  content: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.task.Queues[0].Name), 1)
                  ]),
                  _: 2
                }, [
                  (__props.task?.Queues?.length)
                    ? {
                        name: "default",
                        fn: _withCtx(() => [
                          _createVNode(_unref(ListBulletIcon), { class: "task-card_icon" }),
                          _createElementVNode("div", {
                            textContent: _toDisplayString(__props.task.Queues[0].Name),
                            class: "task-card_queue_text"
                          }, null, 8, _hoisted_3)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1024)
              ], 4))
            : _createCommentVNode("", true),
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Number))
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                textContent: _toDisplayString(__props.task.Id),
                class: "task-card_id",
                style: _normalizeStyle(elementsStyles.value.Id)
              }, null, 12, _hoisted_4))
            : _createCommentVNode("", true),
          (__props.isStatusLeftBlock && __props.viewSettings?.includes(_unref(TaskViewElementEnum).Status))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(TaskCardStatus), {
                  element: statusColumn.value,
                  monitoringTicketPage: __props.monitoringTicketPage,
                  task: __props.task
                }, null, 8, ["element", "monitoringTicketPage", "task"])
              ]))
            : _createCommentVNode("", true),
          (__props.viewSettings?.includes(_unref(TaskViewElementEnum).Name))
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "task-card_name",
                style: _normalizeStyle(elementsStyles.value.Name)
              }, [
                (!__props.hideIconName)
                  ? (_openBlock(), _createBlock(_unref(Bars3BottomLeftIcon), {
                      key: 0,
                      class: "task-card_icon"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  textContent: _toDisplayString(__props.task.Name),
                  class: "task-card_name_text"
                }, null, 8, _hoisted_6)
              ], 4))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parameterColumns.value, (element, index) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(getTaskParameterComponent(element.Type)), {
              class: "task-card_right",
              key: index,
              isStatusLeftBlock: __props.isStatusLeftBlock,
              shortInfoParameter: __props.shortInfoParameter,
              element: element,
              monitoringTicketPage: __props.monitoringTicketPage,
              task: __props.task
            }, null, 8, ["isStatusLeftBlock", "shortInfoParameter", "element", "monitoringTicketPage", "task"]))
          }), 128)),
          (haveLeftSlot.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 6,
                class: _normalizeClass(['task-card_left', { 'slot-left-visible': __props.slotLeftVisible }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                _renderSlot(_ctx.$slots, "left")
              ], 34))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["isDisabled", "to", "class", "style", "onMousedown"]),
      _createVNode(_unref(RemoveTaskModal), {
        ref_key: "$removeTaskModal",
        ref: $removeTaskModal,
        onSuccessRemove: onSuccessRemove
      }, null, 512)
    ]),
    _: 3
  }, 8, ["trigger-buttons"]))
}
}

})